import { useEffect, useState } from "react";
import VideoCard from "@/components/VideoCard";
import { fetchVideos } from "@/lib/api";

const CITIES = ["All", "Houston", "Atlanta", "Dallas", "Los Angeles", "New Orleans", "New York", "San Diego", "Golden Triangle"];

export default function Watch() {
  const [videos, setVideos] = useState([]);
  const [city, setCity] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchVideos(city !== "All" ? { city } : {})
      .then(setVideos)
      .finally(() => setLoading(false));
  }, [city]);

  return (
    <div data-testid="watch-page" className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-brand-500 mb-3">Tastebuds TV</div>
      <h1 className="font-serif font-black text-5xl md:text-7xl leading-[0.98] text-sand-900 mb-4">Watch.</h1>
      <p className="text-lg font-light text-sand-700 max-w-2xl mb-10">
        Kitchen tours, chef interviews, and behind-the-pass stories from across the network.
      </p>

      <div className="flex flex-wrap gap-2.5 mb-12 border-y border-sand-200 py-5" data-testid="watch-city-filter">
        {CITIES.map((c) => (
          <button
            key={c}
            data-testid={`watch-city-${c.toLowerCase().replace(/\s/g, "-")}`}
            onClick={() => setCity(c)}
            className={`px-5 py-2.5 font-mono text-[10px] tracking-[0.2em] uppercase border transition-all active:scale-95 ${
              city === c ? "bg-brand-500 text-sand-50 border-brand-500" : "bg-transparent text-sand-900 border-sand-300 hover:border-brand-500"
            }`}
          >
            {c === "All" ? "All Markets" : c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => <div key={i} className="aspect-video bg-sand-100 animate-pulse" />)}
        </div>
      ) : videos.length === 0 ? (
        <div className="py-16 text-center border border-dashed border-sand-300">
          <p className="font-serif italic text-2xl text-sand-700">No videos yet{city !== "All" ? ` in ${city}` : ""}.</p>
          <p className="mt-2 text-sand-600 font-light">Claim a listing or build a profile to share your first video.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="watch-grid">
          {videos.map((v, i) => <VideoCard key={v.id} video={v} index={i} />)}
        </div>
      )}
    </div>
  );
}
